export default __webpack_public_path__ + "static/media/creatorSlide.59fb6cfa.png";